<template>
  <DiagramBuilder
    v-if="workflowKey"
    :workflowKey="workflowKey"
  />
</template>

<script>
import DiagramBuilder from '@/components/DiagramBuilder'

export default {
  components: {
    DiagramBuilder,
  },
  data() {
    return {
      workflowKey: null
    }
  }
}
</script>
